module.exports = __webpack_public_path__ + "static/img/4cbc9104b4c0904ced7ee7873831cb2.2376c61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/4cbc9104b4c0904ced7ee7873831cb2.jpg
// module id = MHmx
// module chunks = 4